var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.08C1.47 19.08 0.97 18.87 0.59 18.5C0.21 18.12 0 17.62 0 17.08V1.92C0 1.37 0.45 0.919998 1 0.919998C1.55 0.919998 2 1.37 2 1.92V17.09L19 16.93C19.55 16.93 20 17.37 20 17.92C20 18.47 19.56 18.92 19.01 18.93L2 19.09H1.98L2 19.08Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18999 14.87C2.93999 14.87 2.68999 14.78 2.48999 14.59C2.09999 14.2 2.08999 13.57 2.46999 13.18L8.20999 7.31C8.39999 7.12 8.64999 7.01 8.91999 7.01C9.18999 7.01 9.43999 7.12 9.62999 7.3L11.92 9.59L16.88 4.66C17.27 4.27 17.9 4.27 18.29 4.66C18.68 5.05 18.68 5.68 18.29 6.07L12.62 11.71C12.23 12.1 11.6 12.1 11.21 11.71L8.92999 9.43L3.89999 14.58C3.69999 14.78 3.43999 14.88 3.17999 14.88L3.18999 14.87Z",
    fill: "#4FB74A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.89 9.58H18.88C18.33 9.58 17.88 9.12 17.89 8.57L17.93 5.24L14.63 5.28C14.07 5.24 13.63 4.84 13.62 4.29C13.62 3.74 14.06 3.28 14.61 3.28L18.93 3.23C19.21 3.21 19.46 3.33 19.65 3.52C19.84 3.71 19.95 3.97 19.94 4.24L19.89 8.59C19.89 9.14 19.44 9.58 18.89 9.58Z",
    fill: "#4FB74A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.a4a5963fd4b189d04f181a9b63ef4e69.svg";
export { ForwardRef as ReactComponent };